import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "defect-review-admin-container" }
const _hoisted_2 = { class: "scene-switch-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "defect-review-content" }
const _hoisted_5 = { class: "left-panel" }
const _hoisted_6 = { class: "right-title" }
const _hoisted_7 = { class: "right-body" }
const _hoisted_8 = { class: "tree-wrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "node-arrow" }
const _hoisted_11 = { class: "node-label" }
const _hoisted_12 = {
  key: 0,
  class: "tree-children"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "child-label" }
const _hoisted_15 = { class: "right-panel" }
const _hoisted_16 = { class: "card-grid" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "card-text-wrap" }
const _hoisted_22 = { class: "card-text" }

import { computed, ref, getCurrentInstance, ComponentInternalInstance, onBeforeMount, watch } from "vue";
import { useStore } from 'vuex';
import { $config, $enum } from '@/global/index';
import { getOmsDeviceDefectList, getOmsDeviceDefectTree, getSceneTypes, updateOmsDeviceDefect, uploadOmsDeviceDefectPicture } from '@/service';
import { removeStorage } from '@/utils/storage';

interface ITreeChild {
  id: string;
  label: string;
}

interface ITreeNode {
  id: string;
  label: string;
  children: ITreeChild[];
}

interface IDefectCard {
  id: string;
  label: string;
  categoryId: string;
  childId: string;
  image: string;
  sort: number;
  isVisible: number;
}

interface ISceneItem {
  id: string;
  sceneName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const isSearchHover = ref(false);
const isSearchFocus = ref(false);
const searchKeyword = ref("");
const sceneList = ref<ISceneItem[]>([]);
const activeSceneTypeId = ref('');
const displayOnly = ref(false);

const treeData = ref<ITreeNode[]>([]);
const expandedNodeIds = ref<Set<string>>(new Set());
const activeNodeId = ref("");
const activeChildId = ref("");
const allCards = ref<IDefectCard[]>([]);
const uploadInputRef = ref<HTMLInputElement | null>(null);
const pendingUploadCard = ref<IDefectCard | null>(null);
const uploadingCardId = ref('');
const deletingCardId = ref('');
const fileBaseUrl = $config.FILE_ROOT_PATH || '';

const searchStateClass = computed(() => {
  if (isSearchFocus.value || isSearchHover.value) return "is-hover";
  if (searchKeyword.value.trim()) return "is-filled";
  return "is-default";
});

const filteredCards = computed(() => {
  return allCards.value.filter((item) => {
    const matchNode = item.categoryId === activeNodeId.value;
    const matchChild =
      !activeChildId.value || item.childId === activeChildId.value;
    return matchNode && matchChild;
  });
});

const groupedCards = computed(() => {
  const result: IDefectCard[][] = [];
  for (let i = 0; i < filteredCards.value.length; i += 3) {
    result.push(filteredCards.value.slice(i, i + 3));
  }
  return result;
});

function toggleNode(nodeId: string) {
  if (expandedNodeIds.value.has(nodeId)) {
    expandedNodeIds.value.delete(nodeId);
  } else {
    expandedNodeIds.value.add(nodeId);
  }
  // 点击父节点时仅切换展开/收起，不改变当前已选子节点和右侧列表
}

function handleSelectChild(nodeId: string, childId: string) {
  activeNodeId.value = nodeId;
  activeChildId.value = childId;
  getDefectListData(childId);
}

function handleSearchSubmit() {
  getTreeData(searchKeyword.value.trim());
}

function handleToggleDisplayOnly() {
  displayOnly.value = !displayOnly.value;
  getTreeData(searchKeyword.value.trim());
}

function handleSceneChange(sceneId: string) {
  if (!sceneId || sceneId === activeSceneTypeId.value) return;
  activeSceneTypeId.value = sceneId;
  getTreeData(searchKeyword.value.trim(), sceneId);
}

function handleCardClick(card: IDefectCard) {
  return card;
}

function handleUploadPlaceholderClick(card: IDefectCard) {
  if (uploadingCardId.value || deletingCardId.value) return;
  pendingUploadCard.value = card;
  if (uploadInputRef.value) {
    uploadInputRef.value.value = '';
    uploadInputRef.value.click();
  }
}

async function handleDeleteImage(card: IDefectCard) {
  if (deletingCardId.value || uploadingCardId.value) return;
  deletingCardId.value = card.id;
  try {
    const params = {
      id: card.id,
      description: card.label,
      imageUrl: '',
      positionId: card.childId,
      sort: card.sort,
    };
    const { code, data, message } = await updateOmsDeviceDefect(params);
    if (code === $enum.EnumResult.OVERDUE) {
      handleOmsTokenOverdue();
      return;
    }
    if (code !== $enum.EnumResult.SUCCESS || data !== true) {
      proxy?.vknMessage.error({
        message: message || "删除图片失败，请稍后重试！",
        duration: 1500,
      });
      return;
    }
    await getDefectListData(card.childId, activeSceneTypeId.value);
    proxy?.vknMessage.success({
      message: "删除图片成功！",
      duration: 1500,
    });
  } finally {
    deletingCardId.value = '';
  }
}

function resetPageState() {
  treeData.value = [];
  allCards.value = [];
  activeNodeId.value = '';
  activeChildId.value = '';
  expandedNodeIds.value = new Set();
}

function formatImageUrl(url: string) {
  if (!url) return '';
  // if (/^https?:\/\//i.test(url)) return url;
  return `${fileBaseUrl}${url}`;
}

async function handleFileSelected(event: Event) {
  const target = event.target as HTMLInputElement | null;
  const file = target?.files?.[0];
  const card = pendingUploadCard.value;
  if (!file || !card) return;
  if (!file.type.startsWith('image/')) {
    proxy?.vknMessage.error({
      message: "请选择图片文件！",
      duration: 1500,
    });
    return;
  }

  uploadingCardId.value = card.id;
  try {
    const formData = new FormData();
    formData.append('file', file);
    const uploadRes = await uploadOmsDeviceDefectPicture(formData as unknown as object);
    if (uploadRes.code === $enum.EnumResult.OVERDUE) {
      handleOmsTokenOverdue();
      return;
    }
    if (uploadRes.code !== $enum.EnumResult.SUCCESS || !uploadRes.data) {
      proxy?.vknMessage.error({
        message: uploadRes.message || "图片上传失败，请稍后重试！",
        duration: 1500,
      });
      return;
    }

    const imageUrl = String(uploadRes.data || '');
    const updateParams = {
      id: card.id,
      description: card.label,
      imageUrl,
      positionId: card.childId,
      sort: card.sort,
    };
    const updateRes = await updateOmsDeviceDefect(updateParams);
    if (updateRes.code === $enum.EnumResult.OVERDUE) {
      handleOmsTokenOverdue();
      return;
    }
    if (updateRes.code !== $enum.EnumResult.SUCCESS || updateRes.data !== true) {
      proxy?.vknMessage.error({
        message: updateRes.message || "缺陷更新失败，请稍后重试！",
        duration: 1500,
      });
      return;
    }

    proxy?.vknMessage.success({
      message: "图片上传成功！",
      duration: 1500,
    });
    allCards.value = allCards.value.map((item) =>
      item.id === card.id ? { ...item, image: formatImageUrl(imageUrl) } : item
    );
  } finally {
    uploadingCardId.value = '';
    pendingUploadCard.value = null;
    if (target) target.value = '';
  }
}

function handleOmsTokenOverdue() {
  proxy?.vknMessage.error({
    message: "omsToken有误，请重新设置token！",
    duration: 1500,
  });
  setTimeout(() => {
    removeStorage('omsToken');
    resetPageState();
  }, 1500);
}

async function getDefectListData(positionId: string, sceneId?: string) {
  if (!positionId) {
    allCards.value = [];
    return;
  }
  const currentSceneTypeId = sceneId || activeSceneTypeId.value;
  const params = {
    sceneTypeId: currentSceneTypeId,
    positionId,
    displayOnly: displayOnly.value
  };
  const { code, data } = await getOmsDeviceDefectList(params);
  if (code === $enum.EnumResult.OVERDUE) {
    handleOmsTokenOverdue();
    return;
  }
  if (code !== $enum.EnumResult.SUCCESS || !Array.isArray(data)) {
    allCards.value = [];
    return;
  }
  allCards.value = data.map((item: any) => ({
    id: String(item?.id || ''),
    label: item?.description || '',
    categoryId: activeNodeId.value,
    childId: String(positionId),
    image: formatImageUrl(String(item?.imageUrl || '')),
    sort: Number(item?.sort || 0),
    isVisible: Number(item?.isVisible || 0),
  }));
}

async function getSceneListData() {
  if (!store.state.persistence.userInfo.userId || !store.state.persistence.currentTenantId) {
    sceneList.value = [];
    activeSceneTypeId.value = '';
    resetPageState();
    return;
  }
  const params = {
    userId: store.state.persistence.userInfo.userId,
    tenantId: store.state.persistence.currentTenantId,
  };
  const { code, data } = await getSceneTypes(params);
  if (code !== $enum.EnumResult.SUCCESS || !Array.isArray(data)) {
    sceneList.value = [];
    activeSceneTypeId.value = '';
    resetPageState();
    return;
  }

  const nextSceneList = data
    .filter((item: any) => Number(item?.courseTypeId) === 3)
    .map((item: any) => ({
      id: String(item?.id || ''),
      sceneName: item?.sceneName || '',
    }))
    .filter((item: ISceneItem) => item.id);

  sceneList.value = nextSceneList;
  activeSceneTypeId.value = nextSceneList[0]?.id || '';

  if (!activeSceneTypeId.value) {
    resetPageState();
    return;
  }

  await getTreeData('', activeSceneTypeId.value);
}

async function getTreeData(keyword = "", sceneId?: string) {
  const currentSceneTypeId = sceneId || activeSceneTypeId.value;
  if (!currentSceneTypeId) {
    resetPageState();
    return;
  }
  const params = {
    sceneTypeId: currentSceneTypeId,
    keyword,
    displayOnly: displayOnly.value
  };
  const { code, data } = await getOmsDeviceDefectTree(params);
  if (code === $enum.EnumResult.OVERDUE) {
    handleOmsTokenOverdue();
    return
  }
  if (code !== $enum.EnumResult.SUCCESS) {
    resetPageState();
    return;
  }

  const parts = Array.isArray(data) ? data : [];
  treeData.value = parts.map((part: any) => ({
    id: String(part?.id || ""),
    label: part?.name || "",
    children: (Array.isArray(part?.positions) ? part.positions : []).map((position: any) => ({
      id: String(position?.id || ""),
      label: position?.name || "",
    })),
  }));

  const defaultPositionId = String(data?.defaultPositionId || '');
  const defaultNode = treeData.value.find((node) =>
    node.children.some((child) => child.id === defaultPositionId)
  );
  const firstNode = treeData.value[0];
  const targetNode = defaultNode || firstNode;
  const targetChildId =
    defaultPositionId && targetNode?.children.some((child) => child.id === defaultPositionId)
      ? defaultPositionId
      : targetNode?.children?.[0]?.id || '';

  activeNodeId.value = targetNode?.id || '';
  activeChildId.value = targetChildId;
  expandedNodeIds.value = new Set(targetNode?.id ? [targetNode.id] : []);

  if (targetChildId) {
    await getDefectListData(targetChildId, currentSceneTypeId);
  } else {
    allCards.value = [];
  }
}

onBeforeMount(() => {
  getSceneListData();
});

watch(
  () => [store.state.persistence.currentTenantId, store.state.persistence.userInfo.userId],
  ([tenantId, userId]) => {
    if (!sceneList.value.length && tenantId && userId) {
      getSceneListData();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (scene) => {
        return (_openBlock(), _createElementBlock("button", {
          key: scene.id,
          class: _normalizeClass(["scene-switch-btn", { primary: activeSceneTypeId.value === scene.id }]),
          onClick: ($event: any) => (handleSceneChange(scene.id))
        }, _toDisplayString(scene.sceneName), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "设备部位", -1)),
          _createElementVNode("div", {
            class: "checkbox-wrapper",
            onClick: handleToggleDisplayOnly
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["custom-checkbox", {
              unchecked: !displayOnly.value,
              checked: displayOnly.value,
            }])
            }, null, 2),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "checkbox-label" }, "已上传图片", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["search-input-wrap", searchStateClass.value]),
            onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (isSearchHover.value = true)),
            onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isSearchHover.value = false))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              type: "text",
              class: "search-input",
              placeholder: "请输入内容",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocus.value = true)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocus.value = false)),
              onKeyup: _withKeys(handleSearchSubmit, ["enter"])
            }, null, 544), [
              [_vModelText, searchKeyword.value]
            ]),
            _createElementVNode("button", {
              class: "search-btn",
              type: "button",
              onClick: handleSearchSubmit,
              "aria-label": "search"
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("span", { class: "search-icon" }, null, -1)
            ]))
          ], 34),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeData.value, (node) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tree-node",
                key: node.id
              }, [
                _createElementVNode("div", {
                  class: "tree-node-row",
                  onClick: ($event: any) => (toggleNode(node.id))
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(expandedNodeIds.value.has(node.id) ? "▾" : "▸"), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(node.label), 1)
                ], 8, _hoisted_9),
                (expandedNodeIds.value.has(node.id) && node.children?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.children, (child) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: child.id,
                          class: _normalizeClass(["tree-child-row", { active: child.id === activeChildId.value }]),
                          onClick: _withModifiers(($event: any) => (handleSelectChild(node.id, child.id)), ["stop"])
                        }, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(child.label), 1)
                        ], 10, _hoisted_13))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedCards.value, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-row",
              key: `row-${rowIndex}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "defect-card",
                  key: item.id,
                  onClick: ($event: any) => (handleCardClick(item))
                }, [
                  (item.image)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("img", {
                          class: "card-image",
                          src: item.image,
                          alt: item.label
                        }, null, 8, _hoisted_18),
                        _createElementVNode("div", {
                          class: "delete-mask",
                          onClick: _withModifiers(($event: any) => (handleDeleteImage(item)), ["stop"])
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "iconfont-line vk_sc_line" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(deletingCardId.value === item.id ? '删除中...' : '删除图片'), 1)
                        ], 8, _hoisted_19)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "upload-placeholder",
                        onClick: _withModifiers(($event: any) => (handleUploadPlaceholderClick(item)), ["stop"])
                      }, _toDisplayString(uploadingCardId.value === item.id ? '上传中...' : '上传图片'), 9, _hoisted_20)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(item.label), 1)
                  ])
                ], 8, _hoisted_17))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("input", {
          ref_key: "uploadInputRef",
          ref: uploadInputRef,
          class: "upload-hidden-input",
          type: "file",
          accept: "image/*",
          onChange: handleFileSelected
        }, null, 544)
      ])
    ])
  ]))
}
}

})